import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import DocumentLink from '../../DocumentLink';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';


class Guia extends Component {

	render() {

		return (

			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={"guia-participante"} page={'guia-participante'}></InfoComponent>	

				{/* Content page */}
				<div className="_the-content">
					<div className='container'>
						<div className="row justify-content-center">
							<div className="col-md-10">
								<div className="row">

									<ErrorBoundary><DocumentLink url={"ObterGuiaParticipante"}   fileImg={'../../assets/img/Guia do Participante_Prancheta 1.png'}   /></ErrorBoundary>
									
								</div>
							</div>
						</div>
					</div>
				</div>
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Guia;